import React, { memo } from 'react';
import { CalculationResults } from '../../types';
import { formatValue } from '../../utils';

interface KPITableProps {
  calculations: CalculationResults;
}

const KPITable: React.FC<KPITableProps> = memo(({ calculations }) => {
  const getColorClass = (value: number, thresholds: { green: number; yellow: number }) => {
    if (value > thresholds.green) return 'bg-green-100 text-green-800';
    if (value >= thresholds.yellow) return 'bg-yellow-100 text-yellow-800';
    return 'bg-red-100 text-red-800';
  };

  return (
    <div className="mb-8 overflow-x-auto">
      <table className="kpi-horizontal-table">
        <thead>
          <tr>
            <th>Kennzahl</th>
            <th>Kaufpreis</th>
            <th>Preisreduktion</th>
            <th>€ / m²</th>
            <th>Brutto-Mietrendite</th>
            <th>EK-Rendite (J1)</th>
            <th>EK-Bedarf</th>
            <th>Monatl. Rate</th>
            <th>Monatl. Kaltmiete</th>
            <th>Monatl. CF (v.St.)</th>
            <th>Monatl. CF (n.St.)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>IST</td>
            <td>{formatValue(calculations.kaufpreisIst, '€')}</td>
            <td>-</td>
            <td>{formatValue(calculations.quadratmeterpreisIst, '€/m²', true)}</td>
            <td>{formatValue(calculations.bruttomietrenditeIst, '%')}</td>
            <td>{formatValue(calculations.eigenkapitalrenditeJahr1Ist, '%')}</td>
            <td>{formatValue(calculations.eigenkapitalIst, '€')}</td>
            <td>{formatValue(calculations.monatlicheRateIst, '€')}</td>
            <td>{formatValue(calculations.monatlicheKaltmieteIst, '€')}</td>
            <td>{formatValue(calculations.monatlicherCashflowJahr1IstVorSteuer, '€')}</td>
            <td>{formatValue(calculations.monatlicherCashflowJahr1IstNachSteuer, '€')}</td>
          </tr>
          <tr id="soll-kpi-row">
            <td>SOLL</td>
            <td>{formatValue(calculations.kaufpreisSoll, '€')}</td>
            <td className={getColorClass(calculations.preisreduktion, { green: 10, yellow: 5 })}>
              {formatValue(calculations.preisreduktion, '%')}
            </td>
            <td>{formatValue(calculations.quadratmeterpreisSoll, '€/m²', true)}</td>
            <td className={getColorClass(calculations.bruttomietrenditeSoll, { green: 4.5, yellow: 3 })}>
              {formatValue(calculations.bruttomietrenditeSoll, '%')}
            </td>
            <td className={getColorClass(calculations.eigenkapitalrenditeJahr1Soll, { green: 10, yellow: 7 })}>
              {formatValue(calculations.eigenkapitalrenditeJahr1Soll, '%')}
            </td>
            <td>{formatValue(calculations.eigenkapitalSoll, '€')}</td>
            <td>{formatValue(calculations.monatlicheRateSoll, '€')}</td>
            <td>{formatValue(calculations.monatlicheKaltmieteSoll, '€')}</td>
            <td>{formatValue(calculations.monatlicherCashflowJahr1SollVorSteuer, '€')}</td>
            <td className={getColorClass(calculations.monatlicherCashflowJahr1SollNachSteuer, { green: 50, yellow: 0 })}>
              {formatValue(calculations.monatlicherCashflowJahr1SollNachSteuer, '€')}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});

KPITable.displayName = 'KPITable';

export default KPITable;